export const profile = {
  name: 'Naman Agarwal',
  title: 'Senior Software Engineer',
  subtitle: 'Full Stack · Distributed Systems',
  location: 'Bangalore, India',
  email: 'namana019@outlook.com',
  phone: '9140263371',
  photo:
    'https://res.cloudinary.com/ddjtltika/image/upload/c_crop,w_600,h_600/v1771338447/1676808278158_fn686r.jpg',
  summary:
    'Senior Software Engineer (4+ yrs) building backend and distributed systems for enterprise-scale systems at Commvault. Shipped an internal developer platform used by 1,000+ engineers, led a full-stack migration cutting page loads by 50%, and previously co-founded a hiring startup as backend/product lead.',
  links: {
    github: 'https://github.com/codingmaven1',
    linkedin: 'https://linkedin.com/in/naman019',
  },
};

export const skills = {
  languages: ['Go', 'Python', 'JavaScript', 'TypeScript', 'SQL'],
  technologies: [
    'FastAPI',
    'Docker',
    'AWS',
    'GCP',
    'PostgreSQL',
    'MongoDB',
    'Jest',
    'Kafka',
    'Redis',
    'Elasticsearch',
    'MCP',
    'LLMs',
    'AI Agents',
    'ReactJS',
    'Next.js',
    'React Query',
    'Redux',
    'Tailwind',
    'Webpack',
  ],
};

export const experience = [
  {
    company: 'Commvault Systems Inc',
    location: 'Bangalore',
    role: 'Senior Engineer',
    period: 'Jan 2022 — Present',
    highlights: [
      'Delivered enterprise-grade Atlassian Confluence backup and recovery capabilities for customers with over 60 TBs of data.',
      'Designed and built production backend features for enterprise NAS and distributed file-system backups at scale, engineering storage protection workflows for large-volume datasets.',
      'Led full-stack migration to Commvault Credential Manager — SQL-backed services + React UI — consolidating secret management across 10+ workflows into a single system.',
      'Owned a Python-based internal backend dependency platform used by 1,000+ engineers, improving build pipeline stability and reducing dependency resolution time by 65%.',
      'Migrated a legacy Angular frontend to React, cutting page load times by 50% across Commvault Cloud workflows.',
    ],
    stack: ['Go', 'React', 'Python', 'SQL', 'Docker'],
  },
  {
    company: 'OnTribe',
    location: 'Gurgaon',
    role: 'Co-Founder and Lead Engineer',
    period: 'Jun 2020 — Aug 2021',
    highlights: [
      'Co-founded a B2B hiring platform; owned backend and product engineering from zero to launch, managing a team of 10 engineers.',
      'Built core frontend architecture with GitHub OAuth login and Dribbble-based portfolio import.',
      'Partnered with DoSelect to automate test scheduling, cutting recruiter manual effort by 10+ hrs/week.',
      'Shipped payments and analytics (Segment) with product team, lifting onboarding conversion by 40%.',
    ],
    stack: ['React', 'OAuth', 'Segment', 'Payments'],
  },
];

export const projects = [
  {
    name: 'HeardIt',
    tagline: 'AI Brand Social Listening Tool',
    url: 'https://heardit.co',
    status: 'Live',
    description:
      'Social listening engine that monitors Instagram Reels, extracting brand sentiment and repeatable product claims from unstructured vernacular comments across Hindi, Hinglish, Tamil, and more.',
    highlights: [
      'Architected a scalable backend data pipeline with Python/FastAPI REST APIs and PostgreSQL on GCP, ingesting short-form video engagement data and serving results to a React frontend.',
      'Designed a real-time alerting system that identifies emerging PR risks and "white space" trends, enabling marketing teams to transition from reactive monitoring to proactive audience engagement.',
    ],
    stack: ['Python', 'FastAPI', 'React', 'PostgreSQL', 'Docker', 'GCP', 'Gen AI'],
  },
];

export const education = [
  {
    institution: 'CFA Institute',
    degree: 'Chartered Financial Analyst (CFA) Program',
    detail: 'Cleared Level II & Level I',
    period: '2024 — 2025',
  },
  {
    institution: 'VIT Vellore',
    degree: 'B.Tech. in Computer Science and Engineering',
    detail: 'CGPA: 9.14/10',
    period: 'Jun 2018 — Jun 2022',
  }
];

export const navItems = [
  { id: 'about', label: 'About' },
  { id: 'experience', label: 'Experience' },
  { id: 'projects', label: 'Projects' },
  { id: 'skills', label: 'Skills' },
  { id: 'education', label: 'Education' },
  { id: 'contact', label: 'Contact' },
];
